__turbopack_context__.v({
  "icon": "external-link-module-scss-module__bmiJga__icon",
});
